import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import { getCurrentUser } from '../services/store-service';

import AvatarBase from './avatar-base';
import Popout from './popout';
import Tooltip from './tooltip';
import UserCard from 'components/UserCard';

import iconClock from '../images/alpha-clock.png';

class MessageUser extends Component {
    state = {
        popoutVisible: false
    }

    handleClick = () => {
        this.popoutCtrl && this.popoutCtrl.show()
    }

    handlePopoutShow = () => {
        this.setState({
            popoutVisible: true
        });
    }

    handlePopoutHide = () => {
        this.setState({
            popoutVisible: false
        });
    }

    handleUserProfileClick = () => {
        this.popoutCtrl.hide();
    }

    get avatarElement() {
        let isOnline;
        if (this.props.online) {
            isOnline = true;
        } else if (this.props.id === getCurrentUser().id) {
            if (getCurrentUser().available === false) {
                isOnline = false;
            } else {
                isOnline = true;
            }
        }

        return (
            <AvatarBase
                className={this.props.bot ? 'bot' : ''}
                image={this.props.avatar}
                color={this.props.color}
                text={this.props.initials}
                showStatus={!this.props.bot}
                online={this.props.online || this.props.id === getCurrentUser()}
            />
        )
    }

    componentDidMount() {
        this.props.provideController && this.props.provideController({
            showPopout: () => {
                this.popoutCtrl && this.popoutCtrl.show();
            }
        });
    }

    componentWillUnmount() {
        this.props.provideController && this.props.provideController(null);
    }

    render() {
        const { t } = this.props;

        if (this.props.noTooltip) {
            return (
                <div className="message-user">
                    { this.avatarElement }
                </div>
            );
        }

        return (
            <div className="message-user" onClick={this.handleClick}>
                {
                    this.props.bot ? (
                        <Tooltip
                            type="popout"
                            className="medium orbit-help-tooltip"
                            placement="right-start"
                            tooltip={
                                <div className="popout-inner">
                                    <div className="popout-body">
                                        <div className="side">
                                            <img src={iconClock} alt="clock" />
                                        </div>

                                        <div className="body">
                                            <h4>{ t('bot.name') }</h4>

                                            <p>{ t('bot.description') }</p>
                                        </div>
                                    </div>
                                </div>
                            }
                        >
                            <div>
                                { this.avatarElement }
                            </div>
                        </Tooltip>
                    ) : (
                        <React.Fragment>
                            { this.avatarElement }

                            <Popout provideController={ctrl => this.popoutCtrl = ctrl} onShow={this.handlePopoutShow} onHide={this.handlePopoutHide} className="user-card-holder" xAlign="right" yAlign="top">
                                <UserCard
                                    id={this.props.id}
                                    image={this.props.avatar}
                                    color={this.props.color}
                                    foregroundColor={this.props.secondary_color}
                                    initials={this.props.initials}
                                    name={this.props.name}
                                    online={this.props.online}
                                    email={this.props.email}
                                    timezone={this.props.tz_offset}
                                    removed={this.props.removed}
                                    role={this.props.role}
                                    pending={this.props.pending}
                                    onUserProfileClick={this.handleUserProfileClick}
                                />
                            </Popout>
                        </React.Fragment>
                    )

                }
            </div>
        );
    }
}

export default withTranslation('chat')(MessageUser);
